export class ColumnDefinition {
  constructor(column = {}, index = 0) {
    this.index = index;
    this.row = column.row || null;
    this.header = column.header || null;
    this.meta = column.meta || null;
    this.sortingFn = column.sortingFn || null;
    this.sortingState = column.sortingState || null;
    this.size = column.size || null;
    this.minSize = column.minSize || null;
    this.maxSize = column.maxSize || null;
    this.frozen = column.frozen || false;
    this.alignFrozen = column.alignFrozen || null;
  }

  isValid() {
    let valid = true;
    const errorList = [];

    if (!this.row) {
      errorList.push('missing row definition, ex: row: { field: "street" }');
      valid = false;
    }

    if (!this.header) {
      errorList.push('missing header definition, ex: header: { name: "Street" }');
      valid = false;
    }

    if (![null, 'left', 'right'].includes(this.alignFrozen)) {
      errorList.push('alignFrozen available values: null, \'left\', \'right\'');
      valid = false;
    }

    if (typeof this.frozen !== 'boolean') {
      errorList.push('frozen available values: false, true');
      valid = false;
    }

    if (!valid && process.env.NODE_ENV === 'development') {
      console.warn(`SbDataTable: Invalid column definition at index ${this.index}:`);
      errorList.forEach((error) => {
        console.warn(`- ${error}`);
      });
    }

    return valid;
  }
}
